import get from 'lodash/get';
import { mapState } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreDetailsPageField',
  components: {
    MarkdownItVueLight
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    originalItem: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false
    },
    updateItemByFieldKey: {
      type: Function,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showRenderedMarkdown: false,
      confirmationDialogs: [],
      noInputRendering: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    itemValue() {
      return get(this.item, this.field.key);
    },
    itemValueDidChange() {
      const originalItemValue = get(this.originalItem, this.field.key);
      if (this.itemValue === '' && (originalItemValue === null || originalItemValue === undefined)) {
        return false;
      }
      return this.itemValue !== originalItemValue;
    },
    fieldLabel() {
      return `${this.field.label}${this.itemValueDidChange ? ` (${this.$i18n_t('Core.DetailsPage.fields.common.didChangePostfix')})` : ''}${this.field.required ? ' *' : ''}`;
    },
    fieldValue() {
      return 'value' in this.field ? this.field.value : this.itemValue;
    },
    showField() {
      return typeof this.field.if === 'function' ? this.field.if(this.item) : true;
    },
    fieldIsDisabled() {
      return !this.editMode || this.field.readonly || this.isProductiveVersion;
    }
  },
  methods: {
    async waitForUserConsent(title, message) {
      const dialog = {
        identifier: `${Date.now()}-${title}-${Math.random()}`,
        title,
        message,
        show: true,
        resolve: null
      };
      const dialogPromise = new Promise(resolve => {
        dialog.resolve = resolve;
      });
      this.confirmationDialogs.push(dialog);
      const result = await dialogPromise;
      dialog.show = false;
      this.confirmationDialogs = this.confirmationDialogs.filter(dialog => dialog.identifier !== dialogPromise.identifier);
      return result;
    },
    onInputChange(value) {
      if (typeof this.field.onInput === 'function') {
        this.field.onInput({
          value,
          item: this.item,
          updateItemByFieldKey: this.updateItemByFieldKey,
          waitForUserConsent: this.waitForUserConsent,
          rerenderInput: () => {
            this.noInputRendering = true;
            this.$nextTick(() => {
              this.noInputRendering = false;
            });
          }
        });
        return;
      }
      this.$emit('input', value);
    },
    combineRules(field) {
      const internalRules = [];
      if (field.required) {
        internalRules.push(v => !!v || this.$i18n_t('Core.DetailsPage.fields.common.requiredField'));
      }
      return [...internalRules, ...get(field, 'rules', [])];
    }
  }
};